/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetDeliveryResponseDtoParticipationEntitlementsInner } from './get-delivery-response-dto-participation-entitlements-inner';

/**
 * 
 * @export
 * @interface AddDeliveryProofResponseDto
 */
export interface AddDeliveryProofResponseDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'deletedAt': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'participationId': string;
    /**
     * Event/Challenge title associated with this delivery
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'eventName'?: string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationStreet': string;
    /**
     * Additional destination address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationAddressLine2'?: string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for destination address data
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationSourceApi': AddDeliveryProofResponseDtoDestinationSourceApiEnum;
    /**
     * Origin name
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'originSourceApi'?: AddDeliveryProofResponseDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'status': AddDeliveryProofResponseDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof AddDeliveryProofResponseDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof AddDeliveryProofResponseDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Whether finisher shirt is included in this delivery
     * @type {boolean}
     * @memberof AddDeliveryProofResponseDto
     */
    'shouldIncludeFinisherShirt'?: boolean;
    /**
     * Finisher shirt size if included
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'finisherShirtSize'?: string;
    /**
     * Whether medal is included in this delivery
     * @type {boolean}
     * @memberof AddDeliveryProofResponseDto
     */
    'shouldIncludeMedal'?: boolean;
    /**
     * List of entitlements included in this delivery
     * @type {Array<GetDeliveryResponseDtoParticipationEntitlementsInner>}
     * @memberof AddDeliveryProofResponseDto
     */
    'participationEntitlements'?: Array<GetDeliveryResponseDtoParticipationEntitlementsInner>;
    /**
     * Destination recipient name (who will receive the package)
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationRecipient'?: string;
    /**
     * Destination contact number
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationContact'?: string;
    /**
     * Complete destination address (street, address line 2, barangay, city, province, postal code, country)
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'destinationAddress'?: string;
    /**
     * User nickname from participation
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'userNickname'?: string;
    /**
     * User full name from participation
     * @type {string}
     * @memberof AddDeliveryProofResponseDto
     */
    'userFullName'?: string;
}

export const AddDeliveryProofResponseDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type AddDeliveryProofResponseDtoDestinationSourceApiEnum = typeof AddDeliveryProofResponseDtoDestinationSourceApiEnum[keyof typeof AddDeliveryProofResponseDtoDestinationSourceApiEnum];
export const AddDeliveryProofResponseDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type AddDeliveryProofResponseDtoOriginSourceApiEnum = typeof AddDeliveryProofResponseDtoOriginSourceApiEnum[keyof typeof AddDeliveryProofResponseDtoOriginSourceApiEnum];
export const AddDeliveryProofResponseDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type AddDeliveryProofResponseDtoStatusEnum = typeof AddDeliveryProofResponseDtoStatusEnum[keyof typeof AddDeliveryProofResponseDtoStatusEnum];


